import { createStore } from 'vuex';

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

// "Build a Kit" (Create Order -> Build a Kit tab). Namespaced, so it cannot
// collide with the root state/getters/actions above.
import kitBuilder from "./modules/kitBuilder";

export default createStore({
  state,
  getters,
  mutations,
  actions,
  modules: {
    kitBuilder,
  }
});
